import BaseCell from '@tcs/client-portal-common/components/molecules/Table/cells/BaseCell';
import { Unicode } from '@tcs/common/utils/unicode';
interface CellProps {
  value: number;
}

const AmountCell = ({ value }: CellProps) => {
  const formattedValue = (value: number) => {
    if (value === 0) {
      return Unicode.EmDash;
    }
    if (value < 0.1) {
      return '< 0.1%';
    }
    return `${value.toFixed(1)}%`;
  };

  return <BaseCell value={formattedValue(value)} align="left" />;
};

export default AmountCell;
